import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleSection />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}